export default __webpack_public_path__ + "static/media/submit.83c99d9c.flac";